import { useEffect } from 'react';

import {
  CollectionPageFilterApply,
  CollectionPageLoadMore,
  CollectionPageTask,
} from '../../../../telemetry/tasks';

import type { ApolloError } from '@apollo/client';
import type { AppsConnectionFragment, CollectionFragment } from '@atlassian/mpac-services-client';

export const useCollectionTelemetry = ({
  slug,
  initialFetchError,
  collection,
  isLoadingMore,
  fetchMoreError,
  sortKey,
  appList,
}: {
  slug?: string | null;
  initialFetchError?: ApolloError;
  collection: CollectionFragment | null;
  isLoadingMore: boolean;
  fetchMoreError?: ApolloError | null;
  sortKey: string;
  appList?: AppsConnectionFragment | null;
}) => {
  useEffect(() => {
    if (slug) {
      CollectionPageTask.start();
    }
  }, [slug]);

  const isCollectionFetchError = initialFetchError && !collection;
  useEffect(() => {
    if (initialFetchError) {
      CollectionPageTask.failed(initialFetchError);
    }
  }, [isCollectionFetchError]);

  useEffect(() => {
    if (collection) {
      CollectionPageTask.succeeded();
    }
  }, [!!collection]);

  useEffect(() => {
    if (isLoadingMore) {
      CollectionPageLoadMore.start();
    }
  }, [isLoadingMore]);

  useEffect(() => {
    if (fetchMoreError) {
      CollectionPageLoadMore.failed(fetchMoreError);
    } else if (appList) {
      CollectionPageLoadMore.succeeded();
    }
  }, [fetchMoreError, appList]);

  useEffect(() => {
    if (sortKey) {
      CollectionPageFilterApply.start();
    }
  }, [sortKey]);

  const isFiltersApplyError = initialFetchError && sortKey;
  useEffect(() => {
    if (isFiltersApplyError) {
      CollectionPageFilterApply.failed(initialFetchError);
    } else if (appList) {
      CollectionPageFilterApply.succeeded();
    }
  }, [isFiltersApplyError, appList]);
};
